export default __webpack_public_path__ + "static/media/shareTunes1.89a90060.png";